import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { PlanActuacion } from '../models/';

@Injectable()
export class PlanActuacionService extends RESTService<any> {

  public juicioDiagnostico: PlanActuacion;
  public juiciosDiagnosticocios: PlanActuacion[];

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * obtenerPlanActuaçio: obtiene el listado completo de PlanActuaçio de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerPlanActuacion(pacienteId: string, visita: string): any {
    return this._http.post(environment.api_host + 'planActuacionConsulta/obtenerPlanActuacionConsulta', {
      numeroExpediente: pacienteId,
      visita: visita,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarPlanActuacion
   * @param params: object
   * @return boolean
   */
  guardarPlanActuacion(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'planActuacionConsulta/guardarPlanActuacion', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }
}



// WEBPACK FOOTER //
// ./src/services/planactuacion.service.ts